import React from 'react';

import DownloadListItem from './DownloadListIem';

import { Card, CardContent, CardHeader, List, makeStyles } from '@material-ui/core';
import { FolderOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme)=>({
    Card : {
        height : '100%',
        borderRadius : '0',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        backgroundColor: 'black',
        color: '#e5e7eb',

    },
    Text : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    CardContent : {
        maxHeight: '55vh',
        overflowY: 'auto',
    }
}))

export default function DownloadList({ sender, files }) {

    const classes = useStyles();


    var displayDownloadedFiles = () => {

        return files.map((file)=>{
            return(
                <DownloadListItem key={file} file={file} />
            )
        })

    }

    return(
        <Card classes={{ root : classes.Card }} >
            <CardHeader classes={{ title : classes.Text }} title={ (sender.length) ? (sender[0].nickname +  " is sending files") : ("Sender is sending files") } avatar={ <FolderOutlined /> }  />
            <CardContent classes={{ root : classes.CardContent }} >
                <List>
                    {displayDownloadedFiles()}
                </List>
            </CardContent>
        </Card>
    )

}